import { createContext } from "react";
const WebHomeProvider = createContext();
export default WebHomeProvider;
